import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8000';

const socket = io(SOCKET_URL, {
  transports: ['websocket', 'polling'],
  autoConnect: true,
  path: '/socket.io',
  reconnection: true,
  // Sin limite de reintentos + backoff exponencial: en moviles el websocket se cae
  // al bloquear pantalla o al cambiar de red; con 5 intentos el cliente quedaba
  // desconectado para siempre y no recibia actualizaciones en tiempo real.
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 30000,
  randomizationFactor: 0.5,
  timeout: 20000,
  auth: (cb) => {
    try {
      const u = JSON.parse(localStorage.getItem('usuario') || 'null');
      cb({ token: u?.token || '' });
    } catch (e) {
      cb({ token: '' });
    }
  },
});

// Eventos de depuración
socket.on('connect', () => {
  console.log('✅ Socket.IO conectado a:', SOCKET_URL);
});

socket.on('connect_error', (error) => {
  console.error('❌ Socket.IO error:', error.message);
});

socket.on('disconnect', (reason) => {
  console.log('🔌 Socket.IO desconectado:', reason);
});

export default socket;

export function reconnectSocketWithAuth() {
  if (socket.connected) {
    socket.disconnect();
  }
  socket.connect();
}

// Une a un cliente del storefront a sus rooms enviando el session_id como prueba
// de pertenencia. El backend valida que el session_id resuelva al mismo idcliente
// y empresa_id del room (evita la fuga cross-tenant de rooms de cliente anonimo).
export function joinClienteRooms(sock, { idcliente, empresaId, sessionId }) {
  if (!sock || !idcliente) return;
  let slug = '';
  try {
    slug = localStorage.getItem('agorax_empresa_slug') || '';
  } catch (e) {
    slug = '';
  }
  const sid = sessionId || '';
  sock.emit('join_room', `cliente_${idcliente}`, sid, slug);
  if (empresaId) sock.emit('join_room', `e${empresaId}_cliente_${idcliente}`, sid, slug);
}
